module.exports = __webpack_public_path__ + "media/images/pic/bunkasai-d373e433b62eaf41db93d94ed2c0bbf7.jpg";